<div class="paginator" [ngClass]="{'noItems': hiddeItems}">
  <section *ngIf="totalItems > itemsPerPage">
    <a [ngClass]="{'disabled': currentPage <= 1}" (click)="goToFirst()"><i class="fas fa-angle-double-left"></i></a>
    <a [ngClass]="{'disabled': currentPage <= 1}" (click)="goTo(currentPage - 1)"><i class="fas fa-angle-left"></i></a>
    <ng-container *ngFor="let page of pages">
      <button [ngClass]="{'active' : page === currentPage}" *ngIf="show(page)" (click)="goTo(page)">{{page}}</button>
    </ng-container>
    <a [ngClass]="{'disabled': currentPage >= totalPages}" (click)="goTo(currentPage + 1)">
      <i class="fas fa-angle-right"></i></a>
    <a [ngClass]="{'disabled': currentPage >= totalPages}" (click)="goToLast()">
      <i class="fas fa-angle-double-right"></i></a>
  </section>
  <label>{{firstItem}} - {{lastItem}} {{'paginator.of'|translate}} {{totalItems}}</label>
</div>
<div *ngIf="!hiddeItems" class="itemsPerPage">
  <label>{{'paginator.itemsPerPage' | translate}}: </label>
  <select (change)="changeItemsPerPage()" [(ngModel)]="itemsPerPage">
    <option *ngFor="let num of numOfItems" value="{{num}}" [selected]="num === itemsPerPage">{{num}}
    </option>
  </select>
</div>
